
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiterview",
      function () {
        return require("private-next-pages/recruiterview/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiterview"])
      });
    }
  